export default {
  pageTitle: 'New Material Request',
  selectLine: 'Production Line',
  selectLinePlaceholder: 'Select a line',
  requestType: 'Request Type',
  typePickup: 'Pickup',
  typeReturn: 'Return',
  typeTransfer: 'Transfer',
  selectMaterial: 'Select Materials',
  searchPlaceholder: 'Search name / code',
  resetMaterial: 'Reset Materials',
  resetConfirmTitle: 'Reset materials?',
  resetConfirmContent: 'This will reset the current material state. Continue?',
  resetCancel: 'Cancel',
  resetSuccess: 'Materials reset successfully',
  resetFail: 'Failed to reset materials',
  colName: 'Material Name',
  colCode: 'Material Code',
  colLocation: 'Location',
  colStock: 'Available Stock',
  colQty: 'Required Qty',
  stockUnit: 'pcs',
  addMaterial: 'Add Material',
  summaryTitle: 'Request Summary',
  summaryLine: 'Line',
  summaryType: 'Type',
  summaryKinds: 'Material Types',
  summaryTotalQty: 'Total Quantity',
  summaryEta: 'Est. Delivery',
  summaryDelivery: 'Delivery Method',
  etaValue: 'Within 3 minutes',
  deliveryMethod: 'SMT Robot Delivery',
  submit: 'Submit Request',
  submitSuccess: 'Material request submitted successfully',
  submitFail: 'Failed to submit material request',
  submitEmpty: 'Please select at least one material',
  submitInvalidQty: 'Please enter a valid required quantity',
  submitNoLine: 'Please select a production line',
  lineA: 'SMT Line Area A',
  lineB: 'SMT Line Area B',
  lineC: 'DIP Line Area C',
}
